export default __webpack_public_path__ + "static/Edrik-6e110b0c9f0852d5b1fb48bd7d64f1b9.jpg";